module.exports = __webpack_public_path__ + "static/media/dynamic-info.bf8d64b7.svg";